import React, { FC } from 'react';

import { ChildrenProps } from '../../../utils';

interface Props extends ChildrenProps {}

export const PaginationFilter: FC<Props> = ({ children }) => {
  return <>{children}</>;
};
